import { defineStore } from 'pinia';
import clientTypesAPI from '@/api/clientTypes';

export const useClientTypeStore = defineStore('clientTypes', {
    state: () => ({
        client_types: [] as any[],
    }),
    actions: {
        async fetchClientTypes(filters: Record<string, any>) {
            try {
                const response = await clientTypesAPI.getClientTypes(filters);
                this.client_types = response.data;
            } catch (error) {
                console.error('Error fetching car listings:', error);
            }
        },
    }
});